import lrRich from './_src/lrRich.vue'

lrRich.install = function(Vue) {
  Vue.component(lrRich.name, lrRich)
}

export default lrRich